<template>
  <div class="footer-wrap">
    <div class="footer-wrap-list">
      <div class="footer-wrap-list-item" v-for="item in menuList" :key="item.id">
        <a class="link title" :href="item.url">{{ item.label }}</a>
        <a class="link" :href="itemChild.url" v-for="itemChild in item.children">{{ itemChild.label }}</a>
      </div>
      <div class="footer-wrap-list-item flex3">
        <div class="qr">
          <div class="qr-item" v-if="config.miniPro.configValue">
            <img :src="config.miniPro.configValue" alt="">
            <div class="qr-item-title">{{ config.miniPro.configName }}</div>
          </div>
          <div class="qr-item" v-if="config.weChat.configValue">
            <img :src="config.weChat.configValue" alt="">
            <div class="qr-item-title">{{ config.weChat.configName }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-wrap-copyright">
      <div>
        2014-2025　一颗认养　致力于国内有机生态互联网领导者<br>
        <a v-if="config.icp.configValue" href="https://beian.miit.gov.cn" target="_blank" title="工信部备案管理系统">{{
          config.icp.configValue }}</a>
        <a v-if="config.ga.configValue" target="_blank"
          :href="`http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${config.ga.configValue}`"><img
            src="@/assets/beian.png">川公网安备 {{ config.ga.configValue }}</a>
        <br><span v-if="config.networkId.configValue">{{ config.networkId.configValue }}</span>
      </div>
      <div>
        电　　话：<a :href="'tel:' + config.tel.configValue" :title="config.tel.configValue">{{ config.tel.configValue
        }}</a><br>
        全国热线：<a :href="'tel:' + config.phone.configValue" :title="config.phone.configValue">{{ config.phone.configValue
        }}</a> <br>
        地　　址：{{ config.address.configValue }}
      </div>
    </div>
    <div class="qualifiList">
      <span v-for="(item, index) in list" :key="item.id">
        <router-link :to="`/qualifications?id=${item.id}`">
          {{ item.name }}
        </router-link>
        <el-divider direction="vertical" v-if="index != (list.length - 1)"></el-divider>
      </span>

    </div>
  </div>
</template>

<script>
import { getConfigList, getPageColumn, getPageContent, getQualificationsList } from '@/API/home'
import { mapGetters } from 'vuex'

export default {
  name: 'Footer',

  data() {
    return {
      menuList: [],
      list: []
    };
  },

  computed: {
    ...mapGetters(['config']),
  },
  mounted() {
    this.getDataGetPageColumn()
    this.getQualifiList()
  },
  methods: {
    getQualifiList() {
      getQualificationsList({ pageNumber: 1, pageSize: 999 }).then(res => {
        this.list = res.data.records
        console.log(this.list);

      })
    },
    getDataGetPageColumn() {
      getPageColumn({
        pageNumber: 1,
        pageSize: 999
      }).then(async res => {
        const menuList = []
        for (let i = 0; i < res.data.records.length; i++) {
          const item = res.data.records[i];
          if (item.id == '1868917501615124482' || item.id == '1868925126838730753' || item.id == '1868933306608152578') {
            item.url = this.formatUrl(item);
            item.children = await this.resChildren(item);
            item.label = item.columnName;
            item.key = item.id;
            delete item.child
            menuList.push(item);
          }
        }
        this.menuList = menuList
      })
    },
    async loadGetPageContent(key) {
      const { data } = await getPageContent({
        key,
        pageNumber: 1,
        pageSize: 20
      })
      return data.records
    },
    //分类路由路径
    formatUrl(record) {
      let url = ''
      switch (record.id) {
        case '1868917501615124482':
          url = '/programme';
          break;
        case '1868925126838730753':
          url = '/product?id=1868925126838730753';
          break;
        case '1868933306608152578':
          url = '/news?id=1868933306608152578';
          break;
      }
      return url;
    },
    //处理children
    async resChildren(record) {
      let children = []
      switch (record.id) {
        case '1868917501615124482':
          const _children = await this.loadGetPageContent(record.id)
          children = _children.map(item => {
            item.key = item.id;
            item.label = item.title;
            item.icon = item.cover ? item.cover.split(",")[0] : [];
            item.url = '/introduce?id=' + item.id;
            return item
          });
          break;
        case '1868925126838730753':
          children = record.child.map(item => {
            item.label = item.columnName;
            item.icon = item.columnIcon;
            item.subtitle = item.remark;
            item.url = '/product-details-list?id=' + item.id;
            return item;
          })
          break;
        case '1868933306608152578':
          children = record.child.map(item => {
            item.label = item.columnName;
            item.icon = item.columnIcon;
            item.subtitle = item.remark;
            item.url = '/news?id=' + item.id;
            return item;
          })
          break;
        default:
          break;
      }
      return children
    },
  },
};
</script>
<style lang="scss" scoped>
.footer-wrap {
  background-color: #333;
  padding: 50px 200px;
  //padding-right: 300px;
  color: #fff;
  box-sizing: border-box;
  width: 100%;

  &-list {
    display: flex;

    &-item {
      flex: 1;

      .link {
        display: block;
        color: rgba(255, 255, 255, 0.75);
        padding: 10px 0px;

        &.title {
          font-weight: bold;
          color: #fff
        }
      }
    }

    .qr {
      display: flex;

      &-item {
        margin-left: 30px;

        img {
          width: 150px;
          height: 150px;
        }

        &-title {
          margin-top: 5px;
          text-align: center;
        }
      }

    }
  }

  &-copyright {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-top: 50px;
    line-height: 200%;

    a {
      color: #14c187;
      margin-right: 10px;
    }
  }
  .qualifiList{
    margin-top: 20px;
    a{
      color: #fff;
    }
  }
}

@media (max-width: 500px) {
  .footer-wrap {
    padding: 30px 20px;

    &-list {
      flex-wrap: wrap;

      &-item {
        font-size: 12px;

        .link {
          padding: 5px 0;
        }

        &.flex3 {
          flex: 3;
        }
      }
    }

    &-copyright {
      font-size: 14px;
    }
  }
}
</style>
